import { FormControlLabel, FormGroup, Checkbox } from "@material-ui/core"
import React from "react"
import { makeStyles } from '@material-ui/core/styles';

const useStyles = makeStyles({
    formControlLabel: {
        cursor: 'pointer',
        fontSize: '11px',
        '&:hover': { backgroundColor: 'transparent' },
    },
    disabled: {
        cursor: 'default',
    },
    checkbox: {
        '&:hover': { backgroundColor: 'transparent' },
        '& .MuiIconButton-root:hover': { backgroundColor: 'transparent' },
    },
});

const CustomArrayOfCheckboxField = (props) => {
    const { element, dataObj, handleCheckboxChange } = props
    const classes = useStyles();
    const options = (() => {
        if (Array.isArray(element?.relatedTo) && element.relatedTo.length > 0) {
            return element.relatedTo.map((item) =>
                typeof item === 'string' ? { value: item, label: item } : { value: item?.value ?? item, label: item?.label ?? item?.value ?? item }
            );
        }
        return element?.data?.type === "custom" ? (element?.data?.options || []) : [];
    })();
    return (
        <FormGroup row={true}>
            {options.map(option => (
                <FormControlLabel
                    key={option.value}
                    className={`${classes.formControlLabel} ${element.readOnly ? classes.disabled : ''}`}
                    control={
                        <Checkbox
                            size="small"
                            color="primary"
                            className={classes.checkbox}
                            checked={dataObj[(element.value || element.name)]?.includes(option.value)}
                            disabled={element.readOnly}
                            onChange={() => handleCheckboxChange((element.value || element.name), option.value, element.type)}
                        />
                    }
                    label={option.label}
                />
            ))}
        </FormGroup>
    )
}

export default CustomArrayOfCheckboxField